import { DollarApollo } from "vue-apollo/types/vue-apollo";
import { FetchResult } from "apollo-link";
import Mutation from "./mutation.gql";

export interface RawResult {
  updateRoom: boolean;
}

export type Args = {
  roomId: string;
  name?: string;
  groupId?: string;
  isDeleted?: boolean;
};

export const updateRoom = async <V>(
  apollo: DollarApollo<V>,
  args: Args
): Promise<FetchResult<RawResult>> => {
  const { roomId, name, groupId, isDeleted } = args;
  const result = apollo.mutate<RawResult>({
    mutation: Mutation,
    variables: {
      roomId,
      name,
      groupId,
      isDeleted
    }
  });
  await apollo.provider.defaultClient.cache.reset();
  return result;
};
